import {Auth, API} from "aws-amplify";

let apiName = process.env.REACT_APP_APINAME;
let path = "";
let requestBody = "";


class InsurenceService {

    async getAllProducts(callback) {
        
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_GET_ALL_PRODUCTS;
        requestBody = {
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    getProductById(productId, callback){

        let url = process.env.REACT_APP_URL_GET_PRODUCTS_BYID;
        console.log(url);
        fetch(url, 
            {
                method: "post",
                headers: {
                    "Accept": "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    productId:productId,
                    limit:10000,
                    offset:"0"
                })
            }).then(function(res){ return res.json(); })
            .then(function(data){ callback(null, data); })
            .catch(err => callback(err, null));
    }

    getImageUrl(imageName, callback){

        let url = process.env.REACT_APP_ENDPOINT+process.env.REACT_APP_URL_FILE_UPLOAD_GET;
        fetch(url, 
            {
                method: "post",
                headers: {
                    "Accept": "application/json, text/plain, */*",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    folderName: "insurance",
                    fileName: imageName,
                    option: 1
                })
            }).then(function(res){ return res.json(); })
            .then(function(data){ callback(null, data); })
            .catch(err => callback(err, null));
    }

    productApprove(productId, callback){
        let url = process.env.REACT_APP_URL_APPROVE_PRODUCTS;
        fetch(url, 
            {
                method: "post",
                headers: {
                    "Accept": "application/json, text/plain, */*",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: productId,
                })
            }).then(function(res){ return res.json(); })
            .then(function(data){ callback(null, data); })
            .catch(err => callback(err, null));
    }

    async productTransactionList(params = {}, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;

        path = process.env.REACT_APP_URL_PRODUCTS_TRANS;
        console.log(path);
        requestBody = {
            body: {
                ...params
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

}

export default InsurenceService;